import { Component } from '@angular/core';
import { NavComponent } from './nav/nav.component';
import { TitleBarComponent } from './title-bar/title-bar.component';
import { ContentComponent } from './content/content.component';
import { ModalComponent } from './shared/modal/modal.component';
import { SharedService } from './_services/shared.service';
import { CommonModule } from '@angular/common';
import { AuthService } from './_services/auth.service';
import { LoadingIndicatorComponent } from './shared/loading-indicator/loading-indicator.component';

@Component({
  selector: 'app-root',
  imports: [
    NavComponent,
    TitleBarComponent,
    ContentComponent,
    ModalComponent,
    CommonModule,
    LoadingIndicatorComponent,
  ],
  templateUrl: './app.component.html',
  standalone: true,
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'Bernie RDM';

  constructor(
    public sharedService: SharedService,
    public authService: AuthService,
  ) {}

  closeModal() {
    this.sharedService.resetModal();
  }
}
